import * as GriddleModels from "../index";
import { Currency, DateFormat, DecimalCount, FontFamily, FontSize, FontWeight, HorizontalAlignment, ItalicStyle, NegativeStyle, NumberFormat, TextWrap, ThousandsSeparator, UnderlineStyle, VerticalAlignment } from "../index";
var FormatNumber;
(function (FormatNumber) {
    FormatNumber[FormatNumber["Format1"] = 0] = "Format1";
    FormatNumber[FormatNumber["Format2"] = 1] = "Format2";
})(FormatNumber || (FormatNumber = {}));
var FormatPart;
(function (FormatPart) {
    FormatPart[FormatPart["Part1"] = 0] = "Part1";
    FormatPart[FormatPart["Part2"] = 1] = "Part2";
})(FormatPart || (FormatPart = {}));
var FormatType = /** @class */ (function () {
    function FormatType(number, part, mask) {
        this.number = number;
        this.part = part;
        this.mask = mask;
    }
    // Masks for the fields on the part1 of gridFormat1
    FormatType.FONT_WEIGHT = new FormatType(FormatNumber.Format1, FormatPart.Part1, 3);
    FormatType.ITALIC_STYLE = new FormatType(FormatNumber.Format1, FormatPart.Part1, 12);
    FormatType.UNDERLINE_STYLE = new FormatType(FormatNumber.Format1, FormatPart.Part1, 48);
    FormatType.TEXT_WRAP = new FormatType(FormatNumber.Format1, FormatPart.Part1, 192);
    FormatType.ALIGN_HORIZONTAL = new FormatType(FormatNumber.Format1, FormatPart.Part1, 768);
    FormatType.ALIGN_VERTICAL = new FormatType(FormatNumber.Format1, FormatPart.Part1, 3072);
    FormatType.NUMBER_FORMAT = new FormatType(FormatNumber.Format1, FormatPart.Part1, 12288);
    FormatType.THOUSAND_SEPARATOR = new FormatType(FormatNumber.Format1, FormatPart.Part1, 49152);
    FormatType.CURRENCY = new FormatType(FormatNumber.Format1, FormatPart.Part1, 2031616);
    FormatType.NEGATIVE_STYLE = new FormatType(FormatNumber.Format1, FormatPart.Part1, 14680064);
    FormatType.DECIMAL_COUNT = new FormatType(FormatNumber.Format1, FormatPart.Part1, 251658240);
    FormatType.OLD_TASKBAR_COLOR = new FormatType(FormatNumber.Format1, FormatPart.Part1, 4026531840);
    // Masks for the fields on the part2 of gridFormat1
    FormatType.COLOR_FOREGROUND = new FormatType(FormatNumber.Format1, FormatPart.Part2, 63);
    FormatType.COLOR_BACKGROUND = new FormatType(FormatNumber.Format1, FormatPart.Part2, 4032);
    FormatType.FONT_FAMILY = new FormatType(FormatNumber.Format1, FormatPart.Part2, 61440);
    FormatType.FONT_SIZE = new FormatType(FormatNumber.Format1, FormatPart.Part2, 4128768);
    // Masks for the fields on the part1 of gridFormat2
    FormatType.TASKBAR_COLOR = new FormatType(FormatNumber.Format2, FormatPart.Part1, 63);
    FormatType.DATE_FORMAT = new FormatType(FormatNumber.Format2, FormatPart.Part1, 1984);
    return FormatType;
}());
/**
 * This function allows us to use all 32 bits of a signed int for a bit mask
 * by treating it as an unsigned int and converting to a signed float
 */
function convertSigned32IntToFloat(int32) {
    // 2147483647 = mask to remove signed bit
    // 2147483648 = adds the signed bit back as a positive float
    if (int32 < 0)
        int32 = (int32 & 2147483647) + 2147483648;
    return int32;
}
function getFormatValue(gridServiceFormat, formatType) {
    var format;
    switch (formatType.number) {
        case FormatNumber.Format1:
            format = gridServiceFormat.format1;
            break;
        case FormatNumber.Format2:
            format = gridServiceFormat.format2;
            break;
    }
    var formatPart;
    switch (formatType.part) {
        case FormatPart.Part1:
            formatPart = convertSigned32IntToFloat(format & 4294967295);
            break;
        case FormatPart.Part2:
            formatPart = (format / 4294967296) | 0;
            break;
    }
    return convertSigned32IntToFloat(formatPart & formatType.mask);
}
export function getFontWeight(gridServiceFormat) {
    var GridServiceFontWeight;
    (function (GridServiceFontWeight) {
        GridServiceFontWeight[GridServiceFontWeight["BOLD"] = 1] = "BOLD";
    })(GridServiceFontWeight || (GridServiceFontWeight = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.FONT_WEIGHT);
    switch (formatValue) {
        case GridServiceFontWeight.BOLD:
            return GriddleModels.FontWeight.BOLD;
        default:
            return GriddleModels.FontWeight.DEFAULT;
    }
}
export function getItalicStyle(gridServiceFormat) {
    var GridServiceItalicStyle;
    (function (GridServiceItalicStyle) {
        GridServiceItalicStyle[GridServiceItalicStyle["ITALIC"] = 4] = "ITALIC";
    })(GridServiceItalicStyle || (GridServiceItalicStyle = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.ITALIC_STYLE);
    switch (formatValue) {
        case GridServiceItalicStyle.ITALIC:
            return GriddleModels.ItalicStyle.ITALIC;
        default:
            return GriddleModels.ItalicStyle.NONE;
    }
}
export function getUnderlineStyle(gridServiceFormat) {
    var GridServiceUnderlineStyle;
    (function (GridServiceUnderlineStyle) {
        GridServiceUnderlineStyle[GridServiceUnderlineStyle["UNDERLINE"] = 16] = "UNDERLINE";
        GridServiceUnderlineStyle[GridServiceUnderlineStyle["STRIKETHROUGH"] = 32] = "STRIKETHROUGH";
    })(GridServiceUnderlineStyle || (GridServiceUnderlineStyle = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.UNDERLINE_STYLE);
    switch (formatValue) {
        case GridServiceUnderlineStyle.UNDERLINE:
            return GriddleModels.UnderlineStyle.UNDERLINE;
        case GridServiceUnderlineStyle.STRIKETHROUGH:
            return GriddleModels.UnderlineStyle.STRIKETHROUGH;
        default:
            return GriddleModels.UnderlineStyle.NONE;
    }
}
export function getTextWrap(gridServiceFormat) {
    var GridServiceTextWrap;
    (function (GridServiceTextWrap) {
        GridServiceTextWrap[GridServiceTextWrap["ON"] = 64] = "ON";
    })(GridServiceTextWrap || (GridServiceTextWrap = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.TEXT_WRAP);
    switch (formatValue) {
        case GridServiceTextWrap.ON:
            return GriddleModels.TextWrap.ON;
        default:
            return GriddleModels.TextWrap.NONE;
    }
}
export function getHorizontalAlignment(gridServiceFormat) {
    var GridServiceAlignHorizontal;
    (function (GridServiceAlignHorizontal) {
        GridServiceAlignHorizontal[GridServiceAlignHorizontal["RIGHT"] = 256] = "RIGHT";
        GridServiceAlignHorizontal[GridServiceAlignHorizontal["LEFT"] = 512] = "LEFT";
        GridServiceAlignHorizontal[GridServiceAlignHorizontal["CENTER"] = 768] = "CENTER";
    })(GridServiceAlignHorizontal || (GridServiceAlignHorizontal = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.ALIGN_HORIZONTAL);
    switch (formatValue) {
        case GridServiceAlignHorizontal.LEFT:
            return GriddleModels.HorizontalAlignment.LEFT;
        case GridServiceAlignHorizontal.CENTER:
            return GriddleModels.HorizontalAlignment.CENTER;
        case GridServiceAlignHorizontal.RIGHT:
            return GriddleModels.HorizontalAlignment.RIGHT;
        default:
            return GriddleModels.HorizontalAlignment.DEFAULT;
    }
}
export function getVerticalAlignment(gridServiceFormat) {
    var GridServiceAlignVertical;
    (function (GridServiceAlignVertical) {
        GridServiceAlignVertical[GridServiceAlignVertical["TOP"] = 1024] = "TOP";
        GridServiceAlignVertical[GridServiceAlignVertical["BOTTOM"] = 2048] = "BOTTOM";
        GridServiceAlignVertical[GridServiceAlignVertical["MIDDLE"] = 3072] = "MIDDLE";
    })(GridServiceAlignVertical || (GridServiceAlignVertical = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.ALIGN_VERTICAL);
    switch (formatValue) {
        case GridServiceAlignVertical.TOP:
            return GriddleModels.VerticalAlignment.TOP;
        case GridServiceAlignVertical.BOTTOM:
            return GriddleModels.VerticalAlignment.BOTTOM;
        case GridServiceAlignVertical.MIDDLE:
            return GriddleModels.VerticalAlignment.MIDDLE;
        default:
            return GriddleModels.VerticalAlignment.DEFAULT;
    }
}
export function getNumberFormat(gridServiceFormat) {
    var GridServiceNumberFormat;
    (function (GridServiceNumberFormat) {
        GridServiceNumberFormat[GridServiceNumberFormat["NUMBER"] = 4096] = "NUMBER";
        GridServiceNumberFormat[GridServiceNumberFormat["CURRENCY"] = 8192] = "CURRENCY";
        GridServiceNumberFormat[GridServiceNumberFormat["PERCENT"] = 12288] = "PERCENT";
    })(GridServiceNumberFormat || (GridServiceNumberFormat = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.NUMBER_FORMAT);
    switch (formatValue) {
        case GridServiceNumberFormat.NUMBER:
            return GriddleModels.NumberFormat.NUMBER;
        case GridServiceNumberFormat.CURRENCY:
            return GriddleModels.NumberFormat.CURRENCY;
        case GridServiceNumberFormat.PERCENT:
            return GriddleModels.NumberFormat.PERCENT;
        default:
            return GriddleModels.NumberFormat.NONE;
    }
}
export function getThousandsSeparator(gridServiceFormat) {
    var GridServiceThousandsSeparator;
    (function (GridServiceThousandsSeparator) {
        GridServiceThousandsSeparator[GridServiceThousandsSeparator["THOUSANDS_SEPARATOR"] = 16384] = "THOUSANDS_SEPARATOR";
    })(GridServiceThousandsSeparator || (GridServiceThousandsSeparator = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.THOUSAND_SEPARATOR);
    switch (formatValue) {
        case GridServiceThousandsSeparator.THOUSANDS_SEPARATOR:
            return GriddleModels.ThousandsSeparator.COMMA;
        default:
            return GriddleModels.ThousandsSeparator.NONE;
    }
}
export function getCurrencyStyle(gridServiceFormat) {
    var GridServiceCurrency;
    (function (GridServiceCurrency) {
        GridServiceCurrency[GridServiceCurrency["ARS"] = 65536] = "ARS";
        GridServiceCurrency[GridServiceCurrency["AUD"] = 131072] = "AUD";
        GridServiceCurrency[GridServiceCurrency["BRL"] = 196608] = "BRL";
        GridServiceCurrency[GridServiceCurrency["CAD"] = 262144] = "CAD";
        GridServiceCurrency[GridServiceCurrency["CHF"] = 327680] = "CHF";
        GridServiceCurrency[GridServiceCurrency["CLP"] = 393216] = "CLP";
        GridServiceCurrency[GridServiceCurrency["CNY"] = 458752] = "CNY";
        GridServiceCurrency[GridServiceCurrency["CZK"] = 524288] = "CZK";
        GridServiceCurrency[GridServiceCurrency["DKK"] = 589824] = "DKK";
        GridServiceCurrency[GridServiceCurrency["EUR"] = 655360] = "EUR";
        GridServiceCurrency[GridServiceCurrency["GBP"] = 720896] = "GBP";
        GridServiceCurrency[GridServiceCurrency["HKD"] = 786432] = "HKD";
        GridServiceCurrency[GridServiceCurrency["ILS"] = 851968] = "ILS";
        GridServiceCurrency[GridServiceCurrency["INR"] = 917504] = "INR";
        GridServiceCurrency[GridServiceCurrency["JPY"] = 983040] = "JPY";
        GridServiceCurrency[GridServiceCurrency["KRW"] = 1048576] = "KRW";
        GridServiceCurrency[GridServiceCurrency["MXN"] = 1114112] = "MXN";
        GridServiceCurrency[GridServiceCurrency["MYR"] = 1179648] = "MYR";
        GridServiceCurrency[GridServiceCurrency["NOK"] = 1245184] = "NOK";
        GridServiceCurrency[GridServiceCurrency["NZD"] = 1310720] = "NZD";
        GridServiceCurrency[GridServiceCurrency["PHP"] = 1376256] = "PHP";
        GridServiceCurrency[GridServiceCurrency["PLN"] = 1441792] = "PLN";
        GridServiceCurrency[GridServiceCurrency["RON"] = 1507328] = "RON";
        GridServiceCurrency[GridServiceCurrency["RUB"] = 1572864] = "RUB";
        GridServiceCurrency[GridServiceCurrency["SEK"] = 1638400] = "SEK";
        GridServiceCurrency[GridServiceCurrency["SGD"] = 1703936] = "SGD";
        GridServiceCurrency[GridServiceCurrency["TWD"] = 1769472] = "TWD";
        GridServiceCurrency[GridServiceCurrency["USD"] = 1835008] = "USD";
        GridServiceCurrency[GridServiceCurrency["VND"] = 1900544] = "VND";
        GridServiceCurrency[GridServiceCurrency["YTL"] = 1966080] = "YTL";
        GridServiceCurrency[GridServiceCurrency["ZAR"] = 2031616] = "ZAR"; // South Africa
    })(GridServiceCurrency || (GridServiceCurrency = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.CURRENCY);
    switch (formatValue) {
        case GridServiceCurrency.ARS:
            return GriddleModels.Currency.ARS;
        case GridServiceCurrency.AUD:
            return GriddleModels.Currency.AUD;
        case GridServiceCurrency.BRL:
            return GriddleModels.Currency.BRL;
        case GridServiceCurrency.CAD:
            return GriddleModels.Currency.CAD;
        case GridServiceCurrency.CHF:
            return GriddleModels.Currency.CHF;
        case GridServiceCurrency.CLP:
            return GriddleModels.Currency.CLP;
        case GridServiceCurrency.CNY:
            return GriddleModels.Currency.CNY;
        case GridServiceCurrency.CZK:
            return GriddleModels.Currency.CZK;
        case GridServiceCurrency.DKK:
            return GriddleModels.Currency.DKK;
        case GridServiceCurrency.EUR:
            return GriddleModels.Currency.EUR;
        case GridServiceCurrency.GBP:
            return GriddleModels.Currency.GBP;
        case GridServiceCurrency.HKD:
            return GriddleModels.Currency.HKD;
        case GridServiceCurrency.ILS:
            return GriddleModels.Currency.ILS;
        case GridServiceCurrency.INR:
            return GriddleModels.Currency.INR;
        case GridServiceCurrency.JPY:
            return GriddleModels.Currency.JPY;
        case GridServiceCurrency.KRW:
            return GriddleModels.Currency.KRW;
        case GridServiceCurrency.MXN:
            return GriddleModels.Currency.MXN;
        case GridServiceCurrency.MYR:
            return GriddleModels.Currency.MYR;
        case GridServiceCurrency.NOK:
            return GriddleModels.Currency.NOK;
        case GridServiceCurrency.NZD:
            return GriddleModels.Currency.NZD;
        case GridServiceCurrency.PHP:
            return GriddleModels.Currency.PHP;
        case GridServiceCurrency.PLN:
            return GriddleModels.Currency.PLN;
        case GridServiceCurrency.RON:
            return GriddleModels.Currency.RON;
        case GridServiceCurrency.RUB:
            return GriddleModels.Currency.RUB;
        case GridServiceCurrency.SEK:
            return GriddleModels.Currency.SEK;
        case GridServiceCurrency.SGD:
            return GriddleModels.Currency.SGD;
        case GridServiceCurrency.TWD:
            return GriddleModels.Currency.TWD;
        case GridServiceCurrency.USD:
            return GriddleModels.Currency.USD;
        case GridServiceCurrency.VND:
            return GriddleModels.Currency.VND;
        case GridServiceCurrency.YTL:
            return GriddleModels.Currency.YTL;
        case GridServiceCurrency.ZAR:
            return GriddleModels.Currency.ZAR;
        default:
            return GriddleModels.Currency.NONE;
    }
}
export function getNegativeStyle(gridServiceFormat) {
    var GridServiceNegativeStyle;
    (function (GridServiceNegativeStyle) {
        GridServiceNegativeStyle[GridServiceNegativeStyle["SIGN_BLACK"] = 2097152] = "SIGN_BLACK";
        GridServiceNegativeStyle[GridServiceNegativeStyle["PAREN_BLACK"] = 4194304] = "PAREN_BLACK";
        GridServiceNegativeStyle[GridServiceNegativeStyle["SIGN_RED"] = 6291456] = "SIGN_RED";
        GridServiceNegativeStyle[GridServiceNegativeStyle["PAREN_RED"] = 8388608] = "PAREN_RED";
    })(GridServiceNegativeStyle || (GridServiceNegativeStyle = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.NEGATIVE_STYLE);
    switch (formatValue) {
        case GridServiceNegativeStyle.SIGN_BLACK:
            return GriddleModels.NegativeStyle.SIGN_BLACK;
        case GridServiceNegativeStyle.PAREN_BLACK:
            return GriddleModels.NegativeStyle.PAREN_BLACK;
        case GridServiceNegativeStyle.SIGN_RED:
            return GriddleModels.NegativeStyle.SIGN_RED;
        case GridServiceNegativeStyle.PAREN_RED:
            return GriddleModels.NegativeStyle.PAREN_RED;
        default:
            return GriddleModels.NegativeStyle.NONE;
    }
}
export function getDecimalCount(gridServiceFormat) {
    var GridServiceDecimalCount;
    (function (GridServiceDecimalCount) {
        GridServiceDecimalCount[GridServiceDecimalCount["ZERO"] = 16777216] = "ZERO";
        GridServiceDecimalCount[GridServiceDecimalCount["ONE"] = 33554432] = "ONE";
        GridServiceDecimalCount[GridServiceDecimalCount["TWO"] = 50331648] = "TWO";
        GridServiceDecimalCount[GridServiceDecimalCount["THREE"] = 67108864] = "THREE";
        GridServiceDecimalCount[GridServiceDecimalCount["FOUR"] = 83886080] = "FOUR";
        GridServiceDecimalCount[GridServiceDecimalCount["FIVE"] = 100663296] = "FIVE";
    })(GridServiceDecimalCount || (GridServiceDecimalCount = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.DECIMAL_COUNT);
    switch (formatValue) {
        case GridServiceDecimalCount.ZERO:
            return GriddleModels.DecimalCount.ZERO;
        case GridServiceDecimalCount.ONE:
            return GriddleModels.DecimalCount.ONE;
        case GridServiceDecimalCount.TWO:
            return GriddleModels.DecimalCount.TWO;
        case GridServiceDecimalCount.THREE:
            return GriddleModels.DecimalCount.THREE;
        case GridServiceDecimalCount.FOUR:
            return GriddleModels.DecimalCount.FOUR;
        case GridServiceDecimalCount.FIVE:
            return GriddleModels.DecimalCount.FIVE;
        default:
            return GriddleModels.DecimalCount.DEFAULT;
    }
}
export function getForegroundColor(gridServiceFormat) {
    var GridServiceForegroundColor;
    (function (GridServiceForegroundColor) {
        GridServiceForegroundColor[GridServiceForegroundColor["TRANSPARENT"] = 41] = "TRANSPARENT";
        GridServiceForegroundColor[GridServiceForegroundColor["RED_0"] = 42] = "RED_0";
        GridServiceForegroundColor[GridServiceForegroundColor["ORANGE_0"] = 43] = "ORANGE_0";
        GridServiceForegroundColor[GridServiceForegroundColor["YELLOW_0"] = 44] = "YELLOW_0";
        GridServiceForegroundColor[GridServiceForegroundColor["GREEN_0"] = 45] = "GREEN_0";
        GridServiceForegroundColor[GridServiceForegroundColor["BLUE_0"] = 46] = "BLUE_0";
        GridServiceForegroundColor[GridServiceForegroundColor["PURPLE_0"] = 47] = "PURPLE_0";
        GridServiceForegroundColor[GridServiceForegroundColor["BROWN_0"] = 48] = "BROWN_0";
        GridServiceForegroundColor[GridServiceForegroundColor["GREY_0"] = 40] = "GREY_0";
        GridServiceForegroundColor[GridServiceForegroundColor["RED_1"] = 49] = "RED_1";
        GridServiceForegroundColor[GridServiceForegroundColor["ORANGE_1"] = 50] = "ORANGE_1";
        GridServiceForegroundColor[GridServiceForegroundColor["YELLOW_1"] = 35] = "YELLOW_1";
        GridServiceForegroundColor[GridServiceForegroundColor["GREEN_1"] = 36] = "GREEN_1";
        GridServiceForegroundColor[GridServiceForegroundColor["BLUE_1"] = 37] = "BLUE_1";
        GridServiceForegroundColor[GridServiceForegroundColor["PURPLE_1"] = 51] = "PURPLE_1";
        GridServiceForegroundColor[GridServiceForegroundColor["BROWN_1"] = 52] = "BROWN_1";
        GridServiceForegroundColor[GridServiceForegroundColor["GREY_1"] = 53] = "GREY_1";
        GridServiceForegroundColor[GridServiceForegroundColor["RED_2"] = 25] = "RED_2";
        GridServiceForegroundColor[GridServiceForegroundColor["ORANGE_2"] = 34] = "ORANGE_2";
        GridServiceForegroundColor[GridServiceForegroundColor["YELLOW_2"] = 27] = "YELLOW_2";
        GridServiceForegroundColor[GridServiceForegroundColor["GREEN_2"] = 19] = "GREEN_2";
        GridServiceForegroundColor[GridServiceForegroundColor["BLUE_2"] = 38] = "BLUE_2";
        GridServiceForegroundColor[GridServiceForegroundColor["PURPLE_2"] = 39] = "PURPLE_2";
        GridServiceForegroundColor[GridServiceForegroundColor["BROWN_2"] = 54] = "BROWN_2";
        GridServiceForegroundColor[GridServiceForegroundColor["GREY_2"] = 32] = "GREY_2";
        GridServiceForegroundColor[GridServiceForegroundColor["RED_3"] = 17] = "RED_3";
        GridServiceForegroundColor[GridServiceForegroundColor["ORANGE_3"] = 10] = "ORANGE_3";
        GridServiceForegroundColor[GridServiceForegroundColor["YELLOW_3"] = 55] = "YELLOW_3";
        GridServiceForegroundColor[GridServiceForegroundColor["GREEN_3"] = 28] = "GREEN_3";
        GridServiceForegroundColor[GridServiceForegroundColor["BLUE_3"] = 14] = "BLUE_3";
        GridServiceForegroundColor[GridServiceForegroundColor["PURPLE_3"] = 31] = "PURPLE_3";
        GridServiceForegroundColor[GridServiceForegroundColor["BROWN_3"] = 2] = "BROWN_3";
        GridServiceForegroundColor[GridServiceForegroundColor["GREY_3"] = 16] = "GREY_3";
        GridServiceForegroundColor[GridServiceForegroundColor["RED_4"] = 9] = "RED_4";
        GridServiceForegroundColor[GridServiceForegroundColor["ORANGE_4"] = 56] = "ORANGE_4";
        GridServiceForegroundColor[GridServiceForegroundColor["YELLOW_4"] = 26] = "YELLOW_4";
        GridServiceForegroundColor[GridServiceForegroundColor["GREEN_4"] = 12] = "GREEN_4";
        GridServiceForegroundColor[GridServiceForegroundColor["BLUE_4"] = 6] = "BLUE_4";
        GridServiceForegroundColor[GridServiceForegroundColor["PURPLE_4"] = 23] = "PURPLE_4";
        GridServiceForegroundColor[GridServiceForegroundColor["BROWN_4"] = 57] = "BROWN_4";
        GridServiceForegroundColor[GridServiceForegroundColor["GREY_4"] = 1] = "GREY_4"; // BLACK
    })(GridServiceForegroundColor || (GridServiceForegroundColor = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.COLOR_FOREGROUND);
    var hexValue;
    switch (formatValue) {
        case GridServiceForegroundColor.TRANSPARENT:
            hexValue = "";
            break;
        case GridServiceForegroundColor.RED_0:
            hexValue = "#FFEBEE";
            break;
        case GridServiceForegroundColor.ORANGE_0:
            hexValue = "#FFF3DF";
            break;
        case GridServiceForegroundColor.YELLOW_0:
            hexValue = "#FFFEE6";
            break;
        case GridServiceForegroundColor.GREEN_0:
            hexValue = "#E7F5E9";
            break;
        case GridServiceForegroundColor.BLUE_0:
            hexValue = "#E2F2FE";
            break;
        case GridServiceForegroundColor.PURPLE_0:
            hexValue = "#F4E4F5";
            break;
        case GridServiceForegroundColor.BROWN_0:
            hexValue = "#F2E8DE";
            break;
        case GridServiceForegroundColor.GREY_0:
            hexValue = "#FFFFFF";
            break;
        case GridServiceForegroundColor.RED_1:
            hexValue = "#FFCCD2";
            break;
        case GridServiceForegroundColor.ORANGE_1:
            hexValue = "#FFE1AF";
            break;
        case GridServiceForegroundColor.YELLOW_1:
            hexValue = "#FEFF85";
            break;
        case GridServiceForegroundColor.GREEN_1:
            hexValue = "#C6E7C8";
            break;
        case GridServiceForegroundColor.BLUE_1:
            hexValue = "#B9DDFC";
            break;
        case GridServiceForegroundColor.PURPLE_1:
            hexValue = "#EBC7EF";
            break;
        case GridServiceForegroundColor.BROWN_1:
            hexValue = "#EEDCCA";
            break;
        case GridServiceForegroundColor.GREY_1:
            hexValue = "#E5E5E5";
            break;
        case GridServiceForegroundColor.RED_2:
            hexValue = "#F87E7D";
            break;
        case GridServiceForegroundColor.ORANGE_2:
            hexValue = "#FFCD7A";
            break;
        case GridServiceForegroundColor.YELLOW_2:
            hexValue = "#FEFF00";
            break;
        case GridServiceForegroundColor.GREEN_2:
            hexValue = "#7ED085";
            break;
        case GridServiceForegroundColor.BLUE_2:
            hexValue = "#5FB3F9";
            break;
        case GridServiceForegroundColor.PURPLE_2:
            hexValue = "#D190DA";
            break;
        case GridServiceForegroundColor.BROWN_2:
            hexValue = "#D0AF8F";
            break;
        case GridServiceForegroundColor.GREY_2:
            hexValue = "#BDBDBD";
            break;
        case GridServiceForegroundColor.RED_3:
            hexValue = "#EA352E";
            break;
        case GridServiceForegroundColor.ORANGE_3:
            hexValue = "#FF8D00";
            break;
        case GridServiceForegroundColor.YELLOW_3:
            hexValue = "#FFED00";
            break;
        case GridServiceForegroundColor.GREEN_3:
            hexValue = "#40B14B";
            break;
        case GridServiceForegroundColor.BLUE_3:
            hexValue = "#1061C3";
            break;
        case GridServiceForegroundColor.PURPLE_3:
            hexValue = "#9210AD";
            break;
        case GridServiceForegroundColor.BROWN_3:
            hexValue = "#974C00";
            break;
        case GridServiceForegroundColor.GREY_3:
            hexValue = "#757575";
            break;
        case GridServiceForegroundColor.RED_4:
            hexValue = "#991310";
            break;
        case GridServiceForegroundColor.ORANGE_4:
            hexValue = "#EA5000";
            break;
        case GridServiceForegroundColor.YELLOW_4:
            hexValue = "#EBC700";
            break;
        case GridServiceForegroundColor.GREEN_4:
            hexValue = "#237F2E";
            break;
        case GridServiceForegroundColor.BLUE_4:
            hexValue = "#0B347D";
            break;
        case GridServiceForegroundColor.PURPLE_4:
            hexValue = "#61058B";
            break;
        case GridServiceForegroundColor.BROWN_4:
            hexValue = "#592C00";
            break;
        case GridServiceForegroundColor.GREY_4:
            hexValue = "#000000";
            break;
        default:
            hexValue = undefined;
    }
    return hexValue;
}
export function getBackgroundColor(gridServiceFormat) {
    var GridServiceBackgroundColor;
    (function (GridServiceBackgroundColor) {
        GridServiceBackgroundColor[GridServiceBackgroundColor["TRANSPARENT"] = 2624] = "TRANSPARENT";
        GridServiceBackgroundColor[GridServiceBackgroundColor["RED_0"] = 2688] = "RED_0";
        GridServiceBackgroundColor[GridServiceBackgroundColor["ORANGE_0"] = 2752] = "ORANGE_0";
        GridServiceBackgroundColor[GridServiceBackgroundColor["YELLOW_0"] = 2816] = "YELLOW_0";
        GridServiceBackgroundColor[GridServiceBackgroundColor["GREEN_0"] = 2880] = "GREEN_0";
        GridServiceBackgroundColor[GridServiceBackgroundColor["BLUE_0"] = 2944] = "BLUE_0";
        GridServiceBackgroundColor[GridServiceBackgroundColor["PURPLE_0"] = 3008] = "PURPLE_0";
        GridServiceBackgroundColor[GridServiceBackgroundColor["BROWN_0"] = 3072] = "BROWN_0";
        GridServiceBackgroundColor[GridServiceBackgroundColor["GREY_0"] = 2560] = "GREY_0";
        GridServiceBackgroundColor[GridServiceBackgroundColor["RED_1"] = 3136] = "RED_1";
        GridServiceBackgroundColor[GridServiceBackgroundColor["ORANGE_1"] = 3200] = "ORANGE_1";
        GridServiceBackgroundColor[GridServiceBackgroundColor["YELLOW_1"] = 2240] = "YELLOW_1";
        GridServiceBackgroundColor[GridServiceBackgroundColor["GREEN_1"] = 2304] = "GREEN_1";
        GridServiceBackgroundColor[GridServiceBackgroundColor["BLUE_1"] = 2368] = "BLUE_1";
        GridServiceBackgroundColor[GridServiceBackgroundColor["PURPLE_1"] = 3264] = "PURPLE_1";
        GridServiceBackgroundColor[GridServiceBackgroundColor["BROWN_1"] = 3328] = "BROWN_1";
        GridServiceBackgroundColor[GridServiceBackgroundColor["GREY_1"] = 3392] = "GREY_1";
        GridServiceBackgroundColor[GridServiceBackgroundColor["RED_2"] = 1600] = "RED_2";
        GridServiceBackgroundColor[GridServiceBackgroundColor["ORANGE_2"] = 2176] = "ORANGE_2";
        GridServiceBackgroundColor[GridServiceBackgroundColor["YELLOW_2"] = 1728] = "YELLOW_2";
        GridServiceBackgroundColor[GridServiceBackgroundColor["GREEN_2"] = 1216] = "GREEN_2";
        GridServiceBackgroundColor[GridServiceBackgroundColor["BLUE_2"] = 2432] = "BLUE_2";
        GridServiceBackgroundColor[GridServiceBackgroundColor["PURPLE_2"] = 2496] = "PURPLE_2";
        GridServiceBackgroundColor[GridServiceBackgroundColor["BROWN_2"] = 3456] = "BROWN_2";
        GridServiceBackgroundColor[GridServiceBackgroundColor["GREY_2"] = 2048] = "GREY_2";
        GridServiceBackgroundColor[GridServiceBackgroundColor["RED_3"] = 1088] = "RED_3";
        GridServiceBackgroundColor[GridServiceBackgroundColor["ORANGE_3"] = 640] = "ORANGE_3";
        GridServiceBackgroundColor[GridServiceBackgroundColor["YELLOW_3"] = 3520] = "YELLOW_3";
        GridServiceBackgroundColor[GridServiceBackgroundColor["GREEN_3"] = 1792] = "GREEN_3";
        GridServiceBackgroundColor[GridServiceBackgroundColor["BLUE_3"] = 896] = "BLUE_3";
        GridServiceBackgroundColor[GridServiceBackgroundColor["PURPLE_3"] = 1984] = "PURPLE_3";
        GridServiceBackgroundColor[GridServiceBackgroundColor["BROWN_3"] = 128] = "BROWN_3";
        GridServiceBackgroundColor[GridServiceBackgroundColor["GREY_3"] = 1024] = "GREY_3";
        GridServiceBackgroundColor[GridServiceBackgroundColor["RED_4"] = 576] = "RED_4";
        GridServiceBackgroundColor[GridServiceBackgroundColor["ORANGE_4"] = 3584] = "ORANGE_4";
        GridServiceBackgroundColor[GridServiceBackgroundColor["YELLOW_4"] = 1664] = "YELLOW_4";
        GridServiceBackgroundColor[GridServiceBackgroundColor["GREEN_4"] = 768] = "GREEN_4";
        GridServiceBackgroundColor[GridServiceBackgroundColor["BLUE_4"] = 384] = "BLUE_4";
        GridServiceBackgroundColor[GridServiceBackgroundColor["PURPLE_4"] = 1472] = "PURPLE_4";
        GridServiceBackgroundColor[GridServiceBackgroundColor["BROWN_4"] = 3648] = "BROWN_4";
        GridServiceBackgroundColor[GridServiceBackgroundColor["GREY_4"] = 64] = "GREY_4";
        // LEGACY COLORS
        // no longer in palette but preserved for mapping to new colors
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_OLIVE_GREEN"] = 192] = "LEGACY_OLIVE_GREEN";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_DARK_GREEN"] = 256] = "LEGACY_DARK_GREEN";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_DARK_TEAL"] = 320] = "LEGACY_DARK_TEAL";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_INDIGO"] = 448] = "LEGACY_INDIGO";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_GREY_80_PERCENT"] = 512] = "LEGACY_GREY_80_PERCENT";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_DARK_YELLOW"] = 704] = "LEGACY_DARK_YELLOW";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_TEAL"] = 832] = "LEGACY_TEAL";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_BLUE_GREY"] = 960] = "LEGACY_BLUE_GREY";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_LIGHT_ORANGE"] = 1152] = "LEGACY_LIGHT_ORANGE";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_SEA_GREEN"] = 1280] = "LEGACY_SEA_GREEN";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_AQUA"] = 1344] = "LEGACY_AQUA";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_LIGHT_BLUE"] = 1408] = "LEGACY_LIGHT_BLUE";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_GREY_40_PERCENT"] = 1536] = "LEGACY_GREY_40_PERCENT";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_TURQUOISE"] = 1856] = "LEGACY_TURQUOISE";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_SKY_BLUE"] = 1920] = "LEGACY_SKY_BLUE";
        GridServiceBackgroundColor[GridServiceBackgroundColor["LEGACY_ROSE"] = 2112] = "LEGACY_ROSE";
    })(GridServiceBackgroundColor || (GridServiceBackgroundColor = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.COLOR_BACKGROUND);
    var hexValue;
    switch (formatValue) {
        case GridServiceBackgroundColor.TRANSPARENT:
            hexValue = "";
            break;
        case GridServiceBackgroundColor.RED_0:
            hexValue = "#FFEBEE";
            break;
        case GridServiceBackgroundColor.ORANGE_0:
            hexValue = "#FFF3DF";
            break;
        case GridServiceBackgroundColor.YELLOW_0:
            hexValue = "#FFFEE6";
            break;
        case GridServiceBackgroundColor.GREEN_0:
            hexValue = "#E7F5E9";
            break;
        case GridServiceBackgroundColor.BLUE_0:
            hexValue = "#E2F2FE";
            break;
        case GridServiceBackgroundColor.PURPLE_0:
            hexValue = "#F4E4F5";
            break;
        case GridServiceBackgroundColor.BROWN_0:
            hexValue = "#F2E8DE";
            break;
        case GridServiceBackgroundColor.GREY_0:
            hexValue = "#FFFFFF";
            break;
        case GridServiceBackgroundColor.RED_1:
            hexValue = "#FFCCD2";
            break;
        case GridServiceBackgroundColor.ORANGE_1:
            hexValue = "#FFE1AF";
            break;
        case GridServiceBackgroundColor.YELLOW_1:
            hexValue = "#FEFF85";
            break;
        case GridServiceBackgroundColor.GREEN_1:
            hexValue = "#C6E7C8";
            break;
        case GridServiceBackgroundColor.BLUE_1:
            hexValue = "#B9DDFC";
            break;
        case GridServiceBackgroundColor.PURPLE_1:
            hexValue = "#EBC7EF";
            break;
        case GridServiceBackgroundColor.BROWN_1:
            hexValue = "#EEDCCA";
            break;
        case GridServiceBackgroundColor.GREY_1:
            hexValue = "#E5E5E5";
            break;
        case GridServiceBackgroundColor.RED_2:
            hexValue = "#F87E7D";
            break;
        case GridServiceBackgroundColor.ORANGE_2:
            hexValue = "#FFCD7A";
            break;
        case GridServiceBackgroundColor.YELLOW_2:
            hexValue = "#FEFF00";
            break;
        case GridServiceBackgroundColor.GREEN_2:
            hexValue = "#7ED085";
            break;
        case GridServiceBackgroundColor.BLUE_2:
            hexValue = "#5FB3F9";
            break;
        case GridServiceBackgroundColor.PURPLE_2:
            hexValue = "#D190DA";
            break;
        case GridServiceBackgroundColor.BROWN_2:
            hexValue = "#D0AF8F";
            break;
        case GridServiceBackgroundColor.GREY_2:
            hexValue = "#BDBDBD";
            break;
        case GridServiceBackgroundColor.RED_3:
            hexValue = "#EA352E";
            break;
        case GridServiceBackgroundColor.ORANGE_3:
            hexValue = "#FF8D00";
            break;
        case GridServiceBackgroundColor.YELLOW_3:
            hexValue = "#FFED00";
            break;
        case GridServiceBackgroundColor.GREEN_3:
            hexValue = "#40B14B";
            break;
        case GridServiceBackgroundColor.BLUE_3:
            hexValue = "#1061C3";
            break;
        case GridServiceBackgroundColor.PURPLE_3:
            hexValue = "#9210AD";
            break;
        case GridServiceBackgroundColor.BROWN_3:
            hexValue = "#974C00";
            break;
        case GridServiceBackgroundColor.GREY_3:
            hexValue = "#757575";
            break;
        case GridServiceBackgroundColor.RED_4:
            hexValue = "#991310";
            break;
        case GridServiceBackgroundColor.ORANGE_4:
            hexValue = "#EA5000";
            break;
        case GridServiceBackgroundColor.YELLOW_4:
            hexValue = "#EBC700";
            break;
        case GridServiceBackgroundColor.GREEN_4:
            hexValue = "#237F2E";
            break;
        case GridServiceBackgroundColor.BLUE_4:
            hexValue = "#0B347D";
            break;
        case GridServiceBackgroundColor.PURPLE_4:
            hexValue = "#61058B";
            break;
        case GridServiceBackgroundColor.BROWN_4:
            hexValue = "#592C00";
            break;
        case GridServiceBackgroundColor.GREY_4:
            hexValue = "#000000";
            break;
        case GridServiceBackgroundColor.LEGACY_OLIVE_GREEN:
            hexValue = "#00750D";
            break;
        case GridServiceBackgroundColor.LEGACY_DARK_GREEN:
            hexValue = "#00750D";
            break;
        case GridServiceBackgroundColor.LEGACY_DARK_TEAL:
            hexValue = "#00395E";
            break;
        case GridServiceBackgroundColor.LEGACY_INDIGO:
            hexValue = "#00395E";
            break;
        case GridServiceBackgroundColor.LEGACY_GREY_80_PERCENT:
            hexValue = "#808080";
            break;
        case GridServiceBackgroundColor.LEGACY_DARK_YELLOW:
            hexValue = "#A9EEAE";
            break;
        case GridServiceBackgroundColor.LEGACY_TEAL:
            hexValue = "#A9EEAE";
            break;
        case GridServiceBackgroundColor.LEGACY_BLUE_GREY:
            hexValue = "#808080";
            break;
        case GridServiceBackgroundColor.LEGACY_LIGHT_ORANGE:
            hexValue = "#FF8100";
            break;
        case GridServiceBackgroundColor.LEGACY_SEA_GREEN:
            hexValue = "#00750D";
            break;
        case GridServiceBackgroundColor.LEGACY_AQUA:
            hexValue = "#95B9F0";
            break;
        case GridServiceBackgroundColor.LEGACY_LIGHT_BLUE:
            hexValue = "#165DEF";
            break;
        case GridServiceBackgroundColor.LEGACY_GREY_40_PERCENT:
            hexValue = "#808080";
            break;
        case GridServiceBackgroundColor.LEGACY_TURQUOISE:
            hexValue = "#95B9F0";
            break;
        case GridServiceBackgroundColor.LEGACY_SKY_BLUE:
            hexValue = "#95B9F0";
            break;
        case GridServiceBackgroundColor.LEGACY_ROSE:
            hexValue = "#FCABAE";
            break;
        default:
            hexValue = undefined;
    }
    return hexValue;
}
export function getFontFamily(gridServiceFormat) {
    var GridServiceFontFamily;
    (function (GridServiceFontFamily) {
        GridServiceFontFamily[GridServiceFontFamily["ARIAL"] = 4096] = "ARIAL";
        GridServiceFontFamily[GridServiceFontFamily["TAHOMA"] = 8192] = "TAHOMA";
        GridServiceFontFamily[GridServiceFontFamily["TIMES"] = 12288] = "TIMES";
        GridServiceFontFamily[GridServiceFontFamily["VERDANA"] = 16384] = "VERDANA";
    })(GridServiceFontFamily || (GridServiceFontFamily = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.FONT_FAMILY);
    switch (formatValue) {
        case GridServiceFontFamily.ARIAL:
            return GriddleModels.FontFamily.ARIAL;
        case GridServiceFontFamily.TAHOMA:
            return GriddleModels.FontFamily.TAHOMA;
        case GridServiceFontFamily.TIMES:
            return GriddleModels.FontFamily.TIMES;
        case GridServiceFontFamily.VERDANA:
            return GriddleModels.FontFamily.VERDANA;
        default:
            return GriddleModels.FontFamily.DEFAULT;
    }
}
export function getFontSize(gridServiceFormat) {
    var GridServiceFontSize;
    (function (GridServiceFontSize) {
        GridServiceFontSize[GridServiceFontSize["EIGHT"] = 65536] = "EIGHT";
        GridServiceFontSize[GridServiceFontSize["NINE"] = 131072] = "NINE";
        GridServiceFontSize[GridServiceFontSize["TEN"] = 196608] = "TEN";
        GridServiceFontSize[GridServiceFontSize["TWELVE"] = 262144] = "TWELVE";
        GridServiceFontSize[GridServiceFontSize["FOURTEEN"] = 327680] = "FOURTEEN";
        GridServiceFontSize[GridServiceFontSize["SIXTEEN"] = 393216] = "SIXTEEN";
        GridServiceFontSize[GridServiceFontSize["EIGHTEEN"] = 458752] = "EIGHTEEN";
        GridServiceFontSize[GridServiceFontSize["TWENTY"] = 524288] = "TWENTY";
        GridServiceFontSize[GridServiceFontSize["TWENTY_FOUR"] = 589824] = "TWENTY_FOUR";
        GridServiceFontSize[GridServiceFontSize["TWENTY_EIGHT"] = 655360] = "TWENTY_EIGHT";
        GridServiceFontSize[GridServiceFontSize["THIRTY_TWO"] = 720896] = "THIRTY_TWO";
        GridServiceFontSize[GridServiceFontSize["THIRTY_SIX"] = 786432] = "THIRTY_SIX";
    })(GridServiceFontSize || (GridServiceFontSize = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.FONT_SIZE);
    switch (formatValue) {
        case GridServiceFontSize.EIGHT:
            return GriddleModels.FontSize.EIGHT;
        case GridServiceFontSize.NINE:
            return GriddleModels.FontSize.NINE;
        case GridServiceFontSize.TEN:
            return GriddleModels.FontSize.TEN;
        case GridServiceFontSize.TWELVE:
            return GriddleModels.FontSize.TWELVE;
        case GridServiceFontSize.FOURTEEN:
            return GriddleModels.FontSize.FOURTEEN;
        case GridServiceFontSize.SIXTEEN:
            return GriddleModels.FontSize.SIXTEEN;
        case GridServiceFontSize.EIGHTEEN:
            return GriddleModels.FontSize.EIGHTEEN;
        case GridServiceFontSize.TWENTY:
            return GriddleModels.FontSize.TWENTY;
        case GridServiceFontSize.TWENTY_FOUR:
            return GriddleModels.FontSize.TWENTY_FOUR;
        case GridServiceFontSize.TWENTY_EIGHT:
            return GriddleModels.FontSize.TWENTY_EIGHT;
        case GridServiceFontSize.THIRTY_TWO:
            return GriddleModels.FontSize.THIRTY_TWO;
        case GridServiceFontSize.THIRTY_SIX:
            return GriddleModels.FontSize.THIRTY_SIX;
        default:
            return GriddleModels.FontSize.DEFAULT;
    }
}
export function getTaskBarColor(gridServiceFormat) {
    var GridServiceTaskBarColor;
    (function (GridServiceTaskBarColor) {
        GridServiceTaskBarColor[GridServiceTaskBarColor["TRANSPARENT"] = 41] = "TRANSPARENT";
        GridServiceTaskBarColor[GridServiceTaskBarColor["RED_0"] = 42] = "RED_0";
        GridServiceTaskBarColor[GridServiceTaskBarColor["ORANGE_0"] = 43] = "ORANGE_0";
        GridServiceTaskBarColor[GridServiceTaskBarColor["YELLOW_0"] = 44] = "YELLOW_0";
        GridServiceTaskBarColor[GridServiceTaskBarColor["GREEN_0"] = 45] = "GREEN_0";
        GridServiceTaskBarColor[GridServiceTaskBarColor["BLUE_0"] = 46] = "BLUE_0";
        GridServiceTaskBarColor[GridServiceTaskBarColor["PURPLE_0"] = 47] = "PURPLE_0";
        GridServiceTaskBarColor[GridServiceTaskBarColor["BROWN_0"] = 48] = "BROWN_0";
        GridServiceTaskBarColor[GridServiceTaskBarColor["GREY_0"] = 40] = "GREY_0";
        GridServiceTaskBarColor[GridServiceTaskBarColor["RED_1"] = 49] = "RED_1";
        GridServiceTaskBarColor[GridServiceTaskBarColor["ORANGE_1"] = 50] = "ORANGE_1";
        GridServiceTaskBarColor[GridServiceTaskBarColor["YELLOW_1"] = 35] = "YELLOW_1";
        GridServiceTaskBarColor[GridServiceTaskBarColor["GREEN_1"] = 36] = "GREEN_1";
        GridServiceTaskBarColor[GridServiceTaskBarColor["BLUE_1"] = 37] = "BLUE_1";
        GridServiceTaskBarColor[GridServiceTaskBarColor["PURPLE_1"] = 51] = "PURPLE_1";
        GridServiceTaskBarColor[GridServiceTaskBarColor["BROWN_1"] = 52] = "BROWN_1";
        GridServiceTaskBarColor[GridServiceTaskBarColor["GREY_1"] = 53] = "GREY_1";
        GridServiceTaskBarColor[GridServiceTaskBarColor["RED_2"] = 25] = "RED_2";
        GridServiceTaskBarColor[GridServiceTaskBarColor["ORANGE_2"] = 34] = "ORANGE_2";
        GridServiceTaskBarColor[GridServiceTaskBarColor["YELLOW_2"] = 27] = "YELLOW_2";
        GridServiceTaskBarColor[GridServiceTaskBarColor["GREEN_2"] = 19] = "GREEN_2";
        GridServiceTaskBarColor[GridServiceTaskBarColor["BLUE_2"] = 38] = "BLUE_2";
        GridServiceTaskBarColor[GridServiceTaskBarColor["PURPLE_2"] = 39] = "PURPLE_2";
        GridServiceTaskBarColor[GridServiceTaskBarColor["BROWN_2"] = 54] = "BROWN_2";
        GridServiceTaskBarColor[GridServiceTaskBarColor["GREY_2"] = 32] = "GREY_2";
        GridServiceTaskBarColor[GridServiceTaskBarColor["RED_3"] = 17] = "RED_3";
        GridServiceTaskBarColor[GridServiceTaskBarColor["ORANGE_3"] = 10] = "ORANGE_3";
        GridServiceTaskBarColor[GridServiceTaskBarColor["YELLOW_3"] = 55] = "YELLOW_3";
        GridServiceTaskBarColor[GridServiceTaskBarColor["GREEN_3"] = 28] = "GREEN_3";
        GridServiceTaskBarColor[GridServiceTaskBarColor["BLUE_3"] = 14] = "BLUE_3";
        GridServiceTaskBarColor[GridServiceTaskBarColor["PURPLE_3"] = 31] = "PURPLE_3";
        GridServiceTaskBarColor[GridServiceTaskBarColor["BROWN_3"] = 2] = "BROWN_3";
        GridServiceTaskBarColor[GridServiceTaskBarColor["GREY_3"] = 16] = "GREY_3";
        GridServiceTaskBarColor[GridServiceTaskBarColor["RED_4"] = 9] = "RED_4";
        GridServiceTaskBarColor[GridServiceTaskBarColor["ORANGE_4"] = 56] = "ORANGE_4";
        GridServiceTaskBarColor[GridServiceTaskBarColor["YELLOW_4"] = 26] = "YELLOW_4";
        GridServiceTaskBarColor[GridServiceTaskBarColor["GREEN_4"] = 12] = "GREEN_4";
        GridServiceTaskBarColor[GridServiceTaskBarColor["BLUE_4"] = 6] = "BLUE_4";
        GridServiceTaskBarColor[GridServiceTaskBarColor["PURPLE_4"] = 23] = "PURPLE_4";
        GridServiceTaskBarColor[GridServiceTaskBarColor["BROWN_4"] = 57] = "BROWN_4";
        GridServiceTaskBarColor[GridServiceTaskBarColor["GREY_4"] = 1] = "GREY_4";
        // LEGACY COLORS
        // no longer in palette but preserved for mapping to new colors
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_OLIVE_GREEN"] = 3] = "LEGACY_OLIVE_GREEN";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_DARK_GREEN"] = 4] = "LEGACY_DARK_GREEN";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_DARK_TEAL"] = 5] = "LEGACY_DARK_TEAL";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_INDIGO"] = 7] = "LEGACY_INDIGO";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_GREY_80_PERCENT"] = 8] = "LEGACY_GREY_80_PERCENT";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_DARK_YELLOW"] = 11] = "LEGACY_DARK_YELLOW";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_TEAL"] = 13] = "LEGACY_TEAL";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_BLUE_GREY"] = 15] = "LEGACY_BLUE_GREY";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_LIGHT_ORANGE"] = 18] = "LEGACY_LIGHT_ORANGE";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_SEA_GREEN"] = 20] = "LEGACY_SEA_GREEN";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_AQUA"] = 21] = "LEGACY_AQUA";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_LIGHT_BLUE"] = 22] = "LEGACY_LIGHT_BLUE";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_GREY_40_PERCENT"] = 24] = "LEGACY_GREY_40_PERCENT";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_TURQUOISE"] = 29] = "LEGACY_TURQUOISE";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_SKY_BLUE"] = 30] = "LEGACY_SKY_BLUE";
        GridServiceTaskBarColor[GridServiceTaskBarColor["LEGACY_ROSE"] = 33] = "LEGACY_ROSE";
    })(GridServiceTaskBarColor || (GridServiceTaskBarColor = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.TASKBAR_COLOR);
    var hexValue;
    switch (formatValue) {
        case GridServiceTaskBarColor.TRANSPARENT:
            hexValue = "";
            break;
        case GridServiceTaskBarColor.RED_0:
            hexValue = "#FFEBEE";
            break;
        case GridServiceTaskBarColor.ORANGE_0:
            hexValue = "#FFF3DF";
            break;
        case GridServiceTaskBarColor.YELLOW_0:
            hexValue = "#FFFEE6";
            break;
        case GridServiceTaskBarColor.GREEN_0:
            hexValue = "#E7F5E9";
            break;
        case GridServiceTaskBarColor.BLUE_0:
            hexValue = "#E2F2FE";
            break;
        case GridServiceTaskBarColor.PURPLE_0:
            hexValue = "#F4E4F5";
            break;
        case GridServiceTaskBarColor.BROWN_0:
            hexValue = "#F2E8DE";
            break;
        case GridServiceTaskBarColor.GREY_0:
            hexValue = "#FFFFFF";
            break;
        case GridServiceTaskBarColor.RED_1:
            hexValue = "#FFCCD2";
            break;
        case GridServiceTaskBarColor.ORANGE_1:
            hexValue = "#FFE1AF";
            break;
        case GridServiceTaskBarColor.YELLOW_1:
            hexValue = "#FEFF85";
            break;
        case GridServiceTaskBarColor.GREEN_1:
            hexValue = "#C6E7C8";
            break;
        case GridServiceTaskBarColor.BLUE_1:
            hexValue = "#B9DDFC";
            break;
        case GridServiceTaskBarColor.PURPLE_1:
            hexValue = "#EBC7EF";
            break;
        case GridServiceTaskBarColor.BROWN_1:
            hexValue = "#EEDCCA";
            break;
        case GridServiceTaskBarColor.GREY_1:
            hexValue = "#E5E5E5";
            break;
        case GridServiceTaskBarColor.RED_2:
            hexValue = "#F87E7D";
            break;
        case GridServiceTaskBarColor.ORANGE_2:
            hexValue = "#FFCD7A";
            break;
        case GridServiceTaskBarColor.YELLOW_2:
            hexValue = "#FEFF00";
            break;
        case GridServiceTaskBarColor.GREEN_2:
            hexValue = "#7ED085";
            break;
        case GridServiceTaskBarColor.BLUE_2:
            hexValue = "#5FB3F9";
            break;
        case GridServiceTaskBarColor.PURPLE_2:
            hexValue = "#D190DA";
            break;
        case GridServiceTaskBarColor.BROWN_2:
            hexValue = "#D0AF8F";
            break;
        case GridServiceTaskBarColor.GREY_2:
            hexValue = "#BDBDBD";
            break;
        case GridServiceTaskBarColor.RED_3:
            hexValue = "#EA352E";
            break;
        case GridServiceTaskBarColor.ORANGE_3:
            hexValue = "#FF8D00";
            break;
        case GridServiceTaskBarColor.YELLOW_3:
            hexValue = "#FFED00";
            break;
        case GridServiceTaskBarColor.GREEN_3:
            hexValue = "#40B14B";
            break;
        case GridServiceTaskBarColor.BLUE_3:
            hexValue = "#1061C3";
            break;
        case GridServiceTaskBarColor.PURPLE_3:
            hexValue = "#9210AD";
            break;
        case GridServiceTaskBarColor.BROWN_3:
            hexValue = "#974C00";
            break;
        case GridServiceTaskBarColor.GREY_3:
            hexValue = "#757575";
            break;
        case GridServiceTaskBarColor.RED_4:
            hexValue = "#991310";
            break;
        case GridServiceTaskBarColor.ORANGE_4:
            hexValue = "#EA5000";
            break;
        case GridServiceTaskBarColor.YELLOW_4:
            hexValue = "#EBC700";
            break;
        case GridServiceTaskBarColor.GREEN_4:
            hexValue = "#237F2E";
            break;
        case GridServiceTaskBarColor.BLUE_4:
            hexValue = "#0B347D";
            break;
        case GridServiceTaskBarColor.PURPLE_4:
            hexValue = "#61058B";
            break;
        case GridServiceTaskBarColor.BROWN_4:
            hexValue = "#592C00";
            break;
        case GridServiceTaskBarColor.GREY_4:
            hexValue = "#000000";
            break;
        case GridServiceTaskBarColor.LEGACY_OLIVE_GREEN:
            hexValue = "#00750D";
            break;
        case GridServiceTaskBarColor.LEGACY_DARK_GREEN:
            hexValue = "#00750D";
            break;
        case GridServiceTaskBarColor.LEGACY_DARK_TEAL:
            hexValue = "#00395E";
            break;
        case GridServiceTaskBarColor.LEGACY_INDIGO:
            hexValue = "#00395E";
            break;
        case GridServiceTaskBarColor.LEGACY_GREY_80_PERCENT:
            hexValue = "#808080";
            break;
        case GridServiceTaskBarColor.LEGACY_DARK_YELLOW:
            hexValue = "#A9EEAE";
            break;
        case GridServiceTaskBarColor.LEGACY_TEAL:
            hexValue = "#A9EEAE";
            break;
        case GridServiceTaskBarColor.LEGACY_BLUE_GREY:
            hexValue = "#808080";
            break;
        case GridServiceTaskBarColor.LEGACY_LIGHT_ORANGE:
            hexValue = "#FF8100";
            break;
        case GridServiceTaskBarColor.LEGACY_SEA_GREEN:
            hexValue = "#00750D";
            break;
        case GridServiceTaskBarColor.LEGACY_AQUA:
            hexValue = "#95B9F0";
            break;
        case GridServiceTaskBarColor.LEGACY_LIGHT_BLUE:
            hexValue = "#165DEF";
            break;
        case GridServiceTaskBarColor.LEGACY_GREY_40_PERCENT:
            hexValue = "#808080";
            break;
        case GridServiceTaskBarColor.LEGACY_TURQUOISE:
            hexValue = "#95B9F0";
            break;
        case GridServiceTaskBarColor.LEGACY_SKY_BLUE:
            hexValue = "#95B9F0";
            break;
        case GridServiceTaskBarColor.LEGACY_ROSE:
            hexValue = "#FCABAE";
            break;
        default:
            hexValue = "";
    }
    return hexValue;
}
export function getDateFormat(gridServiceFormat) {
    var GridServiceDateFormat;
    (function (GridServiceDateFormat) {
        GridServiceDateFormat[GridServiceDateFormat["MMMM_D_YYYY"] = 64] = "MMMM_D_YYYY";
        GridServiceDateFormat[GridServiceDateFormat["MMM_D_YYYY"] = 128] = "MMM_D_YYYY";
        GridServiceDateFormat[GridServiceDateFormat["D_MMM_YYYY"] = 192] = "D_MMM_YYYY";
        GridServiceDateFormat[GridServiceDateFormat["YYYY_MM_DD_HYPHEN"] = 256] = "YYYY_MM_DD_HYPHEN";
        GridServiceDateFormat[GridServiceDateFormat["YYYY_MM_DD_DOT"] = 320] = "YYYY_MM_DD_DOT";
        GridServiceDateFormat[GridServiceDateFormat["DWWWW_MMMM_D_YYYY"] = 384] = "DWWWW_MMMM_D_YYYY";
        GridServiceDateFormat[GridServiceDateFormat["DWWW_DD_MMM_YYYY"] = 448] = "DWWW_DD_MMM_YYYY";
        GridServiceDateFormat[GridServiceDateFormat["DWWW_MM_DD_YYYY"] = 512] = "DWWW_MM_DD_YYYY";
        GridServiceDateFormat[GridServiceDateFormat["MMMM_D"] = 576] = "MMMM_D";
        GridServiceDateFormat[GridServiceDateFormat["D_MMMM"] = 640] = "D_MMMM";
    })(GridServiceDateFormat || (GridServiceDateFormat = {}));
    var formatValue = getFormatValue(gridServiceFormat, FormatType.DATE_FORMAT);
    switch (formatValue) {
        case GridServiceDateFormat.MMMM_D_YYYY:
            return GriddleModels.DateFormat.MMMM_D_YYYY;
        case GridServiceDateFormat.MMM_D_YYYY:
            return GriddleModels.DateFormat.MMM_D_YYYY;
        case GridServiceDateFormat.D_MMM_YYYY:
            return GriddleModels.DateFormat.D_MMM_YYYY;
        case GridServiceDateFormat.YYYY_MM_DD_HYPHEN:
            return GriddleModels.DateFormat.YYYY_MM_DD_HYPHEN;
        case GridServiceDateFormat.YYYY_MM_DD_DOT:
            return GriddleModels.DateFormat.YYYY_MM_DD_DOT;
        case GridServiceDateFormat.DWWWW_MMMM_D_YYYY:
            return GriddleModels.DateFormat.DWWWW_MMMM_D_YYYY;
        case GridServiceDateFormat.DWWW_DD_MMM_YYYY:
            return GriddleModels.DateFormat.DWWW_DD_MMM_YYYY;
        case GridServiceDateFormat.DWWW_MM_DD_YYYY:
            return GriddleModels.DateFormat.DWWW_MM_DD_YYYY;
        case GridServiceDateFormat.MMMM_D:
            return GriddleModels.DateFormat.MMMM_D;
        case GridServiceDateFormat.D_MMMM:
            return GriddleModels.DateFormat.D_MMMM;
        default:
            return GriddleModels.DateFormat.DEFAULT_LOCALE_BASED;
    }
}
export function toGriddleCellFormat(format) {
    var griddleFormat = {
        fontFamily: getFontFamily(format),
        fontSize: getFontSize(format),
        fontWeight: getFontWeight(format),
        italicStyle: getItalicStyle(format),
        underlineStyle: getUnderlineStyle(format),
        textWrap: getTextWrap(format),
        horizontalAlignment: getHorizontalAlignment(format),
        verticalAlignment: getVerticalAlignment(format),
        dateFormat: getDateFormat(format),
        numberFormat: getNumberFormat(format),
        decimalCount: getDecimalCount(format),
        thousandsSeparator: getThousandsSeparator(format),
        negativeStyle: getNegativeStyle(format),
        currency: getCurrencyStyle(format),
        foregroundColor: getForegroundColor(format),
        backgroundColor: getBackgroundColor(format)
    };
    return griddleFormat;
}
export function toGriddleColumnFormat(format) {
    var griddleFormat = {
        fontFamily: getFontFamily(format),
        fontSize: getFontSize(format),
        fontWeight: getFontWeight(format),
        italicStyle: getItalicStyle(format),
        underlineStyle: getUnderlineStyle(format),
        textWrap: getTextWrap(format),
        horizontalAlignment: getHorizontalAlignment(format),
        verticalAlignment: getVerticalAlignment(format),
        dateFormat: getDateFormat(format),
        numberFormat: getNumberFormat(format),
        decimalCount: getDecimalCount(format),
        thousandsSeparator: getThousandsSeparator(format),
        negativeStyle: getNegativeStyle(format),
        currency: getCurrencyStyle(format),
        foregroundColor: getForegroundColor(format),
        backgroundColor: getBackgroundColor(format)
    };
    return griddleFormat;
}
export function toGriddleRowFormat(format) {
    var griddleFormat = {
        fontFamily: getFontFamily(format),
        fontSize: getFontSize(format),
        fontWeight: getFontWeight(format),
        italicStyle: getItalicStyle(format),
        underlineStyle: getUnderlineStyle(format),
        textWrap: getTextWrap(format),
        horizontalAlignment: getHorizontalAlignment(format),
        verticalAlignment: getVerticalAlignment(format),
        dateFormat: getDateFormat(format),
        numberFormat: getNumberFormat(format),
        decimalCount: getDecimalCount(format),
        thousandsSeparator: getThousandsSeparator(format),
        negativeStyle: getNegativeStyle(format),
        currency: getCurrencyStyle(format),
        foregroundColor: getForegroundColor(format),
        backgroundColor: getBackgroundColor(format),
        taskbarColor: getTaskBarColor(format)
    };
    return griddleFormat;
}
/**
 * Merge 2 formats into a single format
 * Primary format has higher priority than secondary format
 * Non-default format has higher priority than default format
 */
export function mergeFormats(primaryFormat, secondaryFormat) {
    return {
        backgroundColor: primaryFormat.backgroundColor ? primaryFormat.backgroundColor : secondaryFormat.backgroundColor,
        currency: primaryFormat.currency !== Currency.NONE ? primaryFormat.currency : secondaryFormat.currency,
        dateFormat: primaryFormat.dateFormat !== DateFormat.DEFAULT_LOCALE_BASED ? primaryFormat.dateFormat : secondaryFormat.dateFormat,
        decimalCount: primaryFormat.decimalCount !== DecimalCount.DEFAULT ? primaryFormat.decimalCount : secondaryFormat.decimalCount,
        fontFamily: primaryFormat.fontFamily !== FontFamily.DEFAULT ? primaryFormat.fontFamily : secondaryFormat.fontFamily,
        fontSize: primaryFormat.fontSize !== FontSize.DEFAULT ? primaryFormat.fontSize : secondaryFormat.fontSize,
        fontWeight: primaryFormat.fontWeight !== FontWeight.DEFAULT ? primaryFormat.fontWeight : secondaryFormat.fontWeight,
        foregroundColor: primaryFormat.foregroundColor ? primaryFormat.foregroundColor : secondaryFormat.foregroundColor,
        horizontalAlignment: primaryFormat.horizontalAlignment !== HorizontalAlignment.DEFAULT
            ? primaryFormat.horizontalAlignment
            : secondaryFormat.horizontalAlignment,
        italicStyle: primaryFormat.italicStyle !== ItalicStyle.NONE ? primaryFormat.italicStyle : secondaryFormat.italicStyle,
        negativeStyle: primaryFormat.negativeStyle !== NegativeStyle.NONE ? primaryFormat.negativeStyle : secondaryFormat.negativeStyle,
        numberFormat: primaryFormat.numberFormat !== NumberFormat.NONE ? primaryFormat.numberFormat : secondaryFormat.numberFormat,
        textWrap: primaryFormat.textWrap !== TextWrap.NONE ? primaryFormat.textWrap : secondaryFormat.textWrap,
        thousandsSeparator: primaryFormat.thousandsSeparator !== ThousandsSeparator.NONE
            ? primaryFormat.thousandsSeparator
            : secondaryFormat.thousandsSeparator,
        underlineStyle: primaryFormat.underlineStyle !== UnderlineStyle.NONE ? primaryFormat.underlineStyle : secondaryFormat.underlineStyle,
        verticalAlignment: primaryFormat.verticalAlignment !== VerticalAlignment.DEFAULT
            ? primaryFormat.verticalAlignment
            : secondaryFormat.verticalAlignment
    };
}
//# sourceMappingURL=FormatMutation.js.map